import ArtifactViewer from "./ArtifactViewer";

export default ArtifactViewer;
